import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslate } from "../i18n";
import { useCategoryContext } from "../components/CategoryContext";
import { LanguageSelect } from "../components/LanguageSelect";
import ThemeToggle from "./ThemeToggle";
import { IcoMenu } from "./layoutIcons";

const ROUTE_LABELS = {
  "/": "layout.topbar.route.dashboard",
  "/posts": "layout.topbar.route.posts",
  "/employee": "layout.topbar.route.employee",
  "/hours": "layout.topbar.route.hours",
  "/gallery": "layout.topbar.route.gallery",
  "/pricelist": "layout.topbar.route.pricelist",
  "/category": "layout.topbar.route.category",
  "/tenants": "layout.topbar.route.tenants",
  "/configs": "layout.topbar.route.configs",
  "/translations": "layout.topbar.route.translations",
  "/users": "layout.topbar.route.users",
  "/roles": "layout.topbar.route.roles",
  "/profile": "layout.topbar.route.profile",
};

export default function TopBar({ isMobile, onMenuToggle }) {
  const location = useLocation();
  const { t } = useTranslate();
  const { categories } = useCategoryContext();
  const matchedCategory = categories.find(
    (category) => `/${category.slug}` === location.pathname,
  );
  const labelKey = ROUTE_LABELS[location.pathname];
  const label = matchedCategory
    ? t(matchedCategory.translationKey || matchedCategory.title)
    : labelKey
      ? t(labelKey)
      : t("layout.topbar.route.unknown");

  return (
    <div
      className="glass-topbar"
      style={{
        height: 60,
        display: "flex",
        alignItems: "center",
        padding: isMobile ? "0 16px" : "0 28px",
        gap: 12,
        flexShrink: 0,
      }}
    >
      {isMobile && (
        <button
          onClick={onMenuToggle}
          className="e-icon-target"
          aria-label={t("layout.sidebar.openMenu")}
          title={t("layout.sidebar.openMenu")}
          style={{
            background: "none",
            border: "none",
            color: "var(--muted2)",
            cursor: "pointer",
            display: "flex",
            padding: 8,
            borderRadius: 8,
            flexShrink: 0,
          }}
        >
          <IcoMenu />
        </button>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          color: "var(--muted)",
          fontSize: 13,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        {!isMobile && (
          <>
            <span>{t("shared.brand.name")}</span>
            <svg
              width={12}
              height={12}
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            >
              <path d="M8 5l5 5-5 5" />
            </svg>
          </>
        )}
        <span
          style={{
            color: "var(--text)",
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
      </div>
      <div
        style={{
          marginLeft: "auto",
          display: "flex",
          gap: isMobile ? 6 : 10,
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        {!isMobile && (
          <>
            <div
              style={{
                width: 7,
                height: 7,
                borderRadius: 4,
                background: "var(--success)",
              }}
            />
            <span style={{ fontSize: 12, color: "var(--muted)" }}>
              {t("layout.topbar.connected")}
            </span>
          </>
        )}

        <ThemeToggle />
        <LanguageSelect />
      </div>
    </div>
  );
}
